module.exports = __webpack_public_path__ + "img/main_zlw.2b014956.jpg";